import { render, staticRenderFns } from "./Parola_uitata.vue?vue&type=template&id=214ca650&scoped=true&"
import script from "./Parola_uitata.vue?vue&type=script&lang=js&"
export * from "./Parola_uitata.vue?vue&type=script&lang=js&"
import style0 from "./Parola_uitata.vue?vue&type=style&index=0&id=214ca650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214ca650",
  null
  
)

export default component.exports